import React from 'react';
import ReactGA4 from 'react-ga4';
import { Navigate, Route, Routes } from 'react-router-dom';

import RootNavbar from '../../components/Navbars/RootNavbar/RootNavbar';
import ROUTES from '../../routes/routes';

class RootLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      layoutPath: '',
    };
  }

  getRoutes = (routes) => {
    const res = routes
      .filter((r) => r.component)
      .map((route) => {
        if (route.path === '/*') {
          return (
            <Route
              path={route.path}
              element={<Navigate to="/login" />}
              key={route.name}
            />
          );
        }
        return (
          <Route
            path={route.path}
            element={
              <route.component
                location={this.props.location}
                history={this.props.history}
              />
            }
            key={route.name}
          />
        );
      });
    return res;
  };

  handleOnColapsedMenu = () => {
    this.setState({
      collapse: !this.state.collapse,
    });
  };

  handleBackground = () => {
    if (
      this.props.location.pathname.includes('support') ||
      this.props.location.pathname.includes('faq') ||
      this.props.location.pathname.includes('contact') ||
      this.props.location.pathname.includes('rules') ||
      this.props.location.pathname.includes('accessibility') ||
      this.props.location.pathname.includes('maintenance')
    )
      return true;
    return false;
  };

  componentDidUpdate() {
    if (window.location.hash !== this.state.layoutPath) {
      this.props.verifyLoggedUser();
      this.setState({ layoutPath: window.location.hash });
    }
  }

  componentDidMount() {
    this.props.verifyLoggedUser();
    this.setState({ layoutPath: window.location.hash });
    ReactGA4.send({ hitType: 'pageview', page: window.location.hash });
  }

  render() {
    return (
      <div
        className={
          this.handleBackground()
            ? 'auth-main-content-nobackground'
            : 'auth-main-content'
        }
      >
        <RootNavbar handleOnColapsedMenu={this.handleOnColapsedMenu} />
        <div
          className={
            this.state.collapse
              ? 'container-content d-none'
              : 'container-content container'
          }
        >
          <Routes>{this.getRoutes(ROUTES.ROOT)}</Routes>
        </div>
      </div>
    );
  }
}
export default RootLayout;
